export const TouchInput = (inputs) => {
    inputs.forEach((input) => {
        input.focus();
        input.blur();
    });
}